
module.exports = {
  // TODO: change your profile information here
  name: "Bhagyashree Aphale",
  greeting: "Hey 👋",
  greetingDescription: "I'm Bhagyashree Aphale and I'm Final year student of Computer Science!",
  githubUrl: "https://github.com/Bhagyashree0806",
  linkedinUrl: "https://www.linkedin.com/in/bhagyashree-aphale-b3291a1b4/",
  cvLink: "https://drive.google.com/file/d/1Se7_U9wmB9R3SQnaAcT-3umUZDJs3h7S/view?usp=sharing",
};
